<template>
    <div id="our_mission" class="module-container module-container-our_mission">
        <div class="container">
            <div class="row">
                <section class="section-container col-40-lg">
                    <div class="element-contaier">
                        <img src="https://res.cloudinary.com/ilovekickboxing/image/upload/v1727889577/ILKB_-_Main_Image_2_vq9zpd.png" alt="Man smiling while leaning against bag" class="img-fluid">
                    </div>
                </section>
                <section class="section-container col-60-lg">
                    <div class="element-contaier">
                        <h1 class="element-text text-align-left font-size-88 font-size-mobile-60 text-color-yellow">Our Mission</h1>
                        <br/>
                    </div>                   
                    <div class="element-contaier">
                        <h2 class="element-text text-align-left font-size-88 font-size-mobile-60">Changing Lives With Kickboxing</h2>
                    </div>
                    <div class="element-contaier">
                        <!-- Modified paragraph element to include role="heading" for visually appearing titles -->
                        <p class="element-text text-align-left font-size-20">
                            <span>
                              Kickboxing fitness isn’t just about getting stronger—it’s about unlocking your physical and mental power. Our instructor-led fitness classes push you to go further, hit harder, and grow stronger every time you show up. You won’t walk off the mat the same—and that’s exactly the point. At I Love Kickboxing, it’s not just a workout. It’s a total transformation.
                            </span>
                        </p>
                    </div>
                    <div class="element-contaier">
                        <a href="/find-location" class="">
                            <button type="button" class="btn btn-primary"> Find Your Strength</button>
                        </a>
                    </div>
                </section>

            </div>
        </div>
    </div>
</template>